import * as React from "react";

import { Root } from "./Warning.styles";

interface WarningProps {
    children: React.ReactNode;
}

export function Warning(props: WarningProps): JSX.Element {
    return <Root>{props.children}</Root>;
}
